import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/templates/LayoutClean.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/templates/LayoutWrapper.tsx");
